import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

export const get_dp_list = createAsyncThunk("dp", async (data) => {
  const body = new FormData();
  body.append("userid", 1);
  body.append("ingress", 1);
  body.append("page", data.page);
  body.append("limit", data.rows);
  const response = await fetch(baseUrl + "dplist.php", {
    method: "POST",
    body: body,
  });
  const res = await response.json();
  console.log(res);
  return res;
});
export const get_all_dp_list = createAsyncThunk("all_dp", async () => {
  const body = new FormData();
  body.append("userid", 1);
  body.append("ingress", 1);
  body.append("page", 1);
  body.append("limit", 10000);
  const response = await fetch(baseUrl + "dplist.php", {
    method: "POST",
    body: body,
  });
  const res = await response.json();
  console.log(res);
  return res;
});

const initialState = {
  dp_list: [],
  loading: false,
  all_dp_list: [],
  all_loading: false,
  total_dp_count: 0,
};
const dplistSlice = createSlice({
  name: "dp",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(get_dp_list.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(get_dp_list.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(get_dp_list.fulfilled, (state, action) => {
      state.loading = false;
      const data = action.payload;
      state.loading = false;
      if (data.success) {
        state.total_dp_count = data.totalcount;
        state.dp_list = data.reponselist;
      } else {
        state.dp_list = [];
      }
    });

    builder.addCase(get_all_dp_list.pending, (state, action) => {
      state.all_loading = true;
    });
    builder.addCase(get_all_dp_list.rejected, (state, action) => {
      state.all_loading = false;
    });
    builder.addCase(get_all_dp_list.fulfilled, (state, action) => {
      state.all_loading = false;
      const data = action.payload;
      if (data.success) {
        state.all_dp_list = data.reponselist;
      } else {
        state.all_dp_list = [];
      }
    });
  },
});
export default dplistSlice.reducer;
